<div class="relative">
  <div class="flex items-center justify-between mt-8 gap-3 px-10">
    <div class="w-[40px] h-[40px] bg-[#285CA5] rounded-full flex items-center justify-center cursor-pointer"
      (click)="goBack()" title="Back">
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.58893 1.16156C7.91437 1.487 7.91437 2.01463 7.58893 2.34007L3.17819 6.75081H12.833C13.2932 6.75081 13.6663 7.12391 13.6663 7.58415C13.6663 8.04438 13.2932 8.41748 12.833 8.41748H3.17819L7.58893 12.8282C7.91437 13.1537 7.91437 13.6813 7.58893 14.0067C7.26349 14.3322 6.73586 14.3322 6.41042 14.0067L0.577085 8.1734C0.251649 7.84797 0.251649 7.32033 0.577085 6.99489L6.41042 1.16156C6.73586 0.836121 7.26349 0.836121 7.58893 1.16156Z"
          fill="white" />
      </svg>
    </div>
    <div class="flex items-center gap-3">
      <button appearance="primary" tuiButton type="submit" size="s" (click)="openDrawerWithPermission()"
        [appDisableUnlessPermission]="'EXTRA_CHARGES_CREATE'">
        Add Extra Charges
      </button>
      <button appearance="primary" tuiButton type="submit" size="s" (click)="printInvoice()"
        [appDisableUnlessPermission]="'INVOICE_VIEW'">
        Print Invoice
      </button>
    </div>
  </div>




  <section class="mx-5 lg:mx-0" id="printJS-form">
    <div class="flex flex-col mt-10 lg:mt-10 xl:mt-16 lg:mx-10 xl:mx-16">
      <div class="flex justify-between items-start">
        <div class="w-[268px] h-[84px]">
          <img src="/assets/logo-vertical.png" class="w-full h-full object-contain" alt="Royal Hospital Logo" />
        </div>
        <div class="flex flex-col items-center justify-center">
          <p class="font-semibold text-[2.25rem] text-[#00AEEF] py-1 m-0 text-center">
            ROYAL HOSPITAL
          </p>
          <p class="font-semibold text-2xl text-[#EC008C] py-2 m-0 p-0 text-center">
            HOME NURSING CARE
          </p>
          <p class="font-normal text-base text-[#212429] py-2 m-0 text-center">
            No. 62, W.A.Silva Mawatha, Wellawatta, Colombo - 06<br />
            Hot Line: 0713257499(WhatsApp), 0760656778, 0114000100
          </p>
        </div>
        <div class="w-[268px] h-[84px] md:hidden lg:hidden xl:block 2xl:block"></div>
      </div>
      <div class="w-full bg-[#D9D9D9] h-[1px] mt-8 mb-3"></div>
      <div class="flex justify-between items-start">
        <div
          style="display: grid; grid-template-columns: 160px 1fr; row-gap: 12px; align-items: center; height: max-content;">
          <p class="text-base font-medium text-[#5B5B5B] !m-0">
            Client Reg No.
          </p>
          <p class="text-base font-medium text-[#353A3F] !m-0">
            {{ client?.refNo || "-" }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] !m-0">
            Invoice No.
          </p>
          <p class="text-base font-medium text-[#285CA5] !m-0">
            {{ generateInvoiceNumber() }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] !m-0">
            Patient Name
          </p>
          <p class="text-base font-medium text-[#353A3F] !m-0">
            {{ client?.name.trim() || "-" }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] !m-0">
            Address
          </p>
          <p class="text-base font-medium text-[#353A3F] !m-0">
            {{ client?.guardianAddress || "-" }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] !m-0">
            Contact No
          </p>
          <p class="text-base font-medium text-[#353A3F] !m-0">
            {{ client?.guardianContactNo || "-" }}
          </p>
        </div>

        <div style="display: grid; grid-template-columns: 180px 1fr; row-gap: 10px; align-items: center;">
          <p style="margin: 0; color: #5B5B5B; font-weight: 500; font-size: 16px;">Date</p>
          <p style="margin: 0; color: #353A3F; font-weight: 500; font-size: 16px;">{{ today | date : "MM/dd/yyyy" }}</p>

          <p style="margin: 0; color: #5B5B5B; font-weight: 500; font-size: 16px;">Billing Period Start</p>
          <p style="margin: 0; color: #353A3F; font-weight: 500; font-size: 16px;">{{ getBillingPeriodStart() | date :
            "MM/dd/yyyy" }}</p>

          <p style="margin: 0; color: #5B5B5B; font-weight: 500; font-size: 16px;">Billing Date</p>
          <p style="margin: 0; color: #353A3F; font-weight: 500; font-size: 16px;">{{ getBillingDate() | date:
            'MM/dd/yyyy' }}</p>
        </div>
      </div>
      <!-- "w-[50rem] md:w-[42rem] lg:w-[52rem] xl:w-[71rem] 2xl:w-[105rem]" -->
      <div class="w-full bg-[#D9D9D9] h-[1px] my-3"></div>

      <p class="text-base font-medium text-[#5B5B5B] mt-8">
        Shift Charges
      </p>

      <div class="mt-2">
        <table tuiTable size="m" class="md:w-full max-w-[55rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Date</th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Nurse name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Roster
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Meal Option
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Type
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Charges
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <!-- Loop through all dates in the month -->

            <ng-container *ngFor="let date of allMonthDates">
              <!-- Check if this date has any shifts -->
              <ng-container *ngIf="getShiftsForDate(date).length > 0; else offDayRow">
                <!-- Loop through all shifts for this date -->
                <tr *ngFor="let shift of getShiftsForDate(date); let first = first">
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#526ED3] text-sm">
                        <span *ngIf="first">{{ date | date : "dd MMM yyyy" }}</span>
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">
                        {{ shift.nurseDetails?.name ?? "Unavailable" }}
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">
                        {{ shift.rooster ? (shift.rooster + " Hour") : "Unavailable" }}
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">
                        {{ shift.mealOption ?? "Unavailable" }}
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">
                        {{ shift.shiftType ?? "Unavailable" }}
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">
                        {{ "LKR " + (shift.charges | number : "1.2-2") }}
                      </p>
                    </div>
                  </td>
                </tr>
              </ng-container>

              <!-- Off day row template -->
              <ng-template #offDayRow>
                <tr class="off-day-row">
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#526ED3] text-sm">
                        {{ date | date : "dd MMM yyyy" }}
                      </p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">Off Day</p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">-</p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">-</p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">-</p>
                    </div>
                  </td>
                  <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                    <div tuiCell="m">
                      <p class="text-[#191C30E5] text-sm">LKR 0.00</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </ng-container>

          </tbody>
        </table>
      </div>

      <p class="text-base font-medium text-[#5B5B5B] mt-24 pt-8">
        Additional Charges
      </p>

      <div class="mt-2">
        <table tuiTable size="m" class="md:w-full max-w-[55rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Date</th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Nurse name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Description / Procedure
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Charge
              </th>
              <th tuiTh style="background-color: #285ca5; color: white" class="no-print">
                Action
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <!-- Loop through each record -->

            <ng-container *ngFor="let record of ExtraChargesRecords">
              <tr>
                <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                  <div tuiCell="m">
                    <p class="text-[#526ED3] text-sm">
                      {{ record.date | date : "dd MMM yyyy" }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ getNurseName(record) }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ getProceduresDisplay(record) }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                  <div tuiCell="m">
                    <p class="text-[#285CA5] text-base font-bold">
                      LKR {{ getGrandTotal(record) | number : "1.2-2"}}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 6px; padding-bottom: 6px" class="no-print">
                  <span tuiStatus>
                    <button *ngIf="!record.archived" (click)="removeExtraCharge(record._id)"
                      class="appearance-none bg-white border-none pt-[3px] m-0 text-[#dc2626] underline decoration-dotted underline-offset-4 hover:text-red-800 cursor-pointer mr-2">
                      Remove
                    </button>
                  </span>
                </td>
              </tr>

              <!-- Breakdown section row -->
              <tr *ngIf="getPaymentBreakdown(record).length > 0">
                <td colspan="6" style="padding: 8px 0; background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;">
                  <div class="px-8">
                    <div class="bg-white rounded border border-gray-200 p-2.5">
                      <p class="text-xs font-semibold text-[#6B7280] mb-2">Payment Breakdown:</p>
                      <div class="grid grid-cols-3 gap-2">
                        <div *ngFor="let payment of getPaymentBreakdown(record)"
                          class="flex justify-between items-center py-1.5 px-2 bg-gray-50 rounded text-xs">
                          <span class="text-[#6B7280]">{{ payment.label }}:</span>
                          <span class="font-semibold text-[#111827] ml-2">{{ payment.amount | number : "1.2-2" }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>

          </tbody>
        </table>
      </div>



      <!-- Summary: left-aligned labels, right-aligned amounts (uniform amount size) -->
      <div class="w-full flex justify-end mt-8">
        <div class="w-full max-w-md grid grid-cols-[minmax(0,1fr)_auto] gap-x-5 gap-y-2.5 items-baseline">
          <p class="text-left text-base font-medium text-[#5B5B5B] my-0">
            Shifts Charges (Net)
          </p>
          <p class="text-right text-base font-normal text-[#777777] tabular-nums whitespace-nowrap my-0">
            {{ shiftTotal | number : "1.2-2" }} LKR
          </p>

          <p class="text-left text-base font-medium text-[#5B5B5B] my-0">
            Additional Charges (Net)
          </p>
          <p class="text-right text-base font-normal text-[#777777] tabular-nums whitespace-nowrap my-0">
            {{ extraChargeTotal | number : "1.2-2" }} LKR
          </p>

          <p class="text-left text-base font-bold text-[#2a2a2a] my-0">Sub Total</p>
          <p class="text-right text-base font-bold text-[#2a2a2a] tabular-nums whitespace-nowrap my-0">
            {{ getNetCharge() | number : "1.2-2" }} LKR
          </p>

          <p class="text-left text-base font-medium text-[#5B5B5B] my-0">
            Additional Charges (Paid)
          </p>
          <p class="text-right text-base font-normal text-[#777777] tabular-nums whitespace-nowrap my-0">
            {{ extraChargeTotal | number : "1.2-2" }} LKR
          </p>

          <p class="text-left text-base font-bold text-[#2a2a2a] my-0">
            Amount to be Paid
          </p>
          <p class="text-right text-base font-bold text-[#2a2a2a] tabular-nums whitespace-nowrap my-0">
            {{ getTotal() | number : "1.2-2" }} LKR
          </p>
        </div>
      </div>

      <div class="w-full bg-[#D9D9D9] h-[1px] my-8"></div>
      <div class="flex space-x-28">
        <div>
          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Account Details
          </p>
        </div>
        <div>
          <p class="text-base font-medium text-[#353A3F] my-[5px]">
            Royal Hospital Home Nursing (pvt) ltd <br />
            Commercial Bank 1000650035 <br />
            Wellawatta 02nd Branch <br />
            Swift Code CCEYLKLX
          </p>
        </div>
      </div>
    </div>
  </section>

</div>